import styled from '@emotion/styled/macro';
import {
    BaseButton,
    forPhoneOnly,
    forTabletLandscapeDown,
    LayoutRow,
    ResponsibilityBadge,
    Variables,
} from '@enter/core';
import { Icon } from '@mdi/react';
import { AlertBar, PageLayoutRow } from 'components';

export const BaseLayoutRow = styled(LayoutRow)`
    align-items: stretch;
    padding: 0 48px;
    margin: 24px 0 0 0;
`;

export const Loader = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0 1 40%;
    justify-content: center;

    & > svg {
        background-color: transparent;
    }
`;

export const StyledIcon = styled(Icon)`
    height: 16px;
    width: 16px;
    vertical-align: middle;
    cursor: pointer;
    fill: ${Variables.Colors.n70};
`;

export const ActionButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const EditButton = styled(BaseButton)`
    align-self: flex-end;
`;

export const ComposeButton = styled(BaseButton)`
    align-self: flex-end;
    padding: 0 11px 0 7px;
`;

export const ComposeIcon = styled(Icon)`
    fill: white;
`;
export const ComposeLabel = styled.span``;

export const MainHeader = styled.div`
    display: flex;
    align-items: center;
    padding-top: 16px;

    ${forPhoneOnly(`
        flex-direction: column;

        & > *:not(:first-of-type) {
            margin-top: 12px;
        }
    `)}
`;

export const MainGroup = styled.div`
    display: flex;
    align-items: center;
`;

export const Title = styled.span`
    display: inline-flex;
    font-size: 28px;
    font-weight: 500;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.p500};
    margin-right: 16px;
    &:empty {
        display: none;
    }
`;

export const StatusBadge = styled(ResponsibilityBadge)`
    margin-right: 16px;
`;

export const Seller = styled.div`
    padding: 6px 12px;
    margin-left: 8px;
    font-size: 14px;
    color: ${Variables.Colors.b300_l62};
    background-color: ${Variables.Colors.b300_l96};
    border-radius: ${Variables.Rounded.small};
    border: 1px solid ${Variables.Colors.b300_l90};
`;

export const Spacer = styled.span`
    flex-grow: 1;
    display: inline-block;
`;

export const SubHeader = styled.div`
    display: flex;
    flex-direction: row;
    padding-top: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${Variables.Colors.platinum};

    & > *:not(:first-of-type) {
        margin-left: 16px;
    }

    ${forPhoneOnly(`
        flex-direction: column;

        & > *:not(:first-of-type) {
            margin-left: 0;
            margin-top: 12px;
        }
    `)}
`;

export const StyledPageLayoutRow = styled(PageLayoutRow)`
    margin-top: 0;
    margin-bottom: 24px;
    flex-wrap: nowrap;
`;

export const OverviewLayoutRow = styled(PageLayoutRow)`
    flex-direction: row;
    margin-top: 0;
    margin-bottom: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;

    ${forTabletLandscapeDown(`
       grid-template-columns: 1fr;
       grid-template-rows: auto auto;
    `)}
`;
export const OverviewLayoutColumn = styled.div`
    display: flex;
    flex: 1 1 calc(50% - 32px);
    flex-direction: column;
    margin-bottom: 24px;

    &:not(:first-of-type) {
        flex: 1 1 calc(50% - 32px);
        margin-right: 0px;
    }
    &:first-of-type > div:not(:last-child) {
        margin-bottom: 24px;
    }

    ${forTabletLandscapeDown(`
        flex: 1 1 100%;
        margin-right: 0;

        /* NB: use specific selector to remove for mobile */
        &:not(:first-of-type) {
            margin-left: 0;
            flex: 1 1 50%;
        }
    `)}
`;

export const StyledAlertBar = styled(AlertBar)`
    margin-right: 32px;
    margin-bottom: 24px;
`;

export const ClaimNumber = styled.span`
    margin-left: 10px;
`;

export const BadgeWrapper = styled.div`
    margin-right: 16px;
`;

export const DisabledAlert = styled.div`
    display: flex;
    justify-content: space-between;
    box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);
    border-radius: 4px;

    color: ${Variables.Colors.white};
    background-color: ${Variables.Colors.warning};
    padding: 10px;
    font-size: 18px;
    align-items: center;
`;

export const SubAlert = styled.div`
    font-size: 14px;
    white-space: pre-line;
`;

export const AlertIcon = styled(Icon)`
    fill: ${Variables.Colors.white};
    margin-right: 10px;
`;

export const AlertContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const AlertButton = styled(BaseButton)`
    color: ${Variables.Colors.white};
`;